import { useState } from "react";
import { Check, RotateCcw, X } from "lucide-react";

export const NoteEditor = ({ note, onSave, onCancel, onReset }) => {
  const [cue, setCue] = useState(note.cue);
  const [text, setText] = useState(note.lines.join("\n"));

  const submit = () => {
    const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
    onSave({ cue: cue.trim(), lines: lines.length ? lines : [""] });
  };

  return (
    <div className="mt-4 space-y-3" data-testid="presenter-note-editor">
      <label className="block">
        <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-zinc-400">Stage cue</span>
        <input
          value={cue}
          onChange={(e) => setCue(e.target.value)}
          data-testid="presenter-cue-input"
          className="mt-1.5 w-full rounded-xl border border-dash/40 bg-dash/10 px-4 py-2.5 text-sm text-orange-100 outline-none focus:border-dash"
        />
      </label>
      <label className="block">
        <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-zinc-400">Script · one line per paragraph · *word* = emphasis</span>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={9}
          autoFocus
          data-testid="presenter-script-textarea"
          className="mt-1.5 w-full resize-y rounded-xl border border-white/15 bg-white/[0.03] px-4 py-3 font-display text-lg leading-relaxed text-zinc-50 outline-none focus:border-dash"
        />
      </label>
      <div className="flex flex-wrap items-center gap-2">
        <button onClick={submit} data-testid="presenter-note-save" className="flex items-center gap-2 rounded-full bg-dash px-4 py-2 text-sm font-semibold text-black transition-colors hover:bg-[#ff8a33]">
          <Check size={15} /> Save
        </button>
        <button onClick={onCancel} data-testid="presenter-note-cancel" className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm text-zinc-200 transition-colors hover:border-white/40">
          <X size={15} /> Cancel
        </button>
        <button onClick={onReset} data-testid="presenter-note-reset" className="ml-auto flex items-center gap-2 rounded-full px-3 py-2 text-xs text-zinc-400 transition-colors hover:text-zinc-100">
          <RotateCcw size={13} /> Restore original
        </button>
      </div>
      <p className="text-xs text-zinc-500">Saved in this browser only.</p>
    </div>
  );
};
